import Review from './Review.page';

export default Review;